export default __webpack_public_path__ + "static/media/inside-logistics.f5062aea.svg";